import i18n from 'i18next'
import { getBrand } from './currentBrand'

export const translate = (key: string, params?: {}): string | null => {
    const keyWithBrand = `${key}_${getBrand()}`
    const brandValue = i18n.t(keyWithBrand, params)

    if (brandValue !== keyWithBrand) {
        return brandValue
    }

    const result = i18n.t(key, params)

    return result === key ? null : result
}

export default translate
